import * as React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Text } from '@/ui';

type DummyInputProps = {
  onFocus: () => void;
  placeholder: string;
  text?: string;
  disabled?: boolean;
};

export const DummyInput = ({
  onFocus,
  placeholder,
  text,
  disabled = false,
}: DummyInputProps) => {
  const { styles, theme } = useStyles(stylesheet);

  return (
    <View>
      {text ? (
        <Text
          type="bodyRegular"
          style={{
            color: theme.colors.text.secondary,
            position: 'absolute',
            left: 12,
            top: -10,
            zIndex: 1,
            paddingLeft: 4,
            paddingRight: 4,
            backgroundColor: theme.colors.background_2,
          }}
        >
          {placeholder}
        </Text>
      ) : null}

      <Pressable
        onPress={onFocus}
        style={[
          styles.container,
          disabled && {
            backgroundColor: theme.colors.input.disabled.fill,
          },
        ]}
        disabled={disabled}
      >
        <View
          style={{
            flexDirection: 'row',
            gap: 8,
            padding: 16,
            alignItems: 'center',
          }}
        >
          {text ? (
            <View>
              <Text type="bodyRegular">{text}</Text>
            </View>
          ) : (
            <Text
              type="bodyRegular"
              style={{ color: theme.colors.text.secondary }}
            >
              {placeholder}
            </Text>
          )}
        </View>
      </Pressable>
    </View>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    width: '100%',
    height: 60,
    borderRadius: 16,
    borderColor: theme.colors.input.active.border,
    borderWidth: 0.2,
    backgroundColor: theme.colors.background_2,
    justifyContent: 'center',
    overflow: 'hidden',
  },
}));
